import React from "react";

const Footer = () => {
  return (
    <div className="h-fit w-full bg-black bottom-0 left-0">
      <p className="text-white text-center py-4">
        This website is made by
        <span className="text-red-500 uppercase"> Rohit Tiwari</span>
      </p>
    </div>
  );
};

export default Footer;
